const modals = {
  Consignment: 'Consignment: Email a Specialist',
  CollectionsAndEstates: 'Collections and Estates: Email a Specialist',
  PrivateSales: 'Private Sales: Email a Specialist',
  ContactUs: 'Contact Us: Email a Specialist',
};

export default modals;
